
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { ProviderModule } from '@/store/modules/provider.module'
import { computed, defineComponent, nextTick, onMounted, reactive, watch } from 'vue';
import OpenConsoleApi from './api/OpenConsoleApi';
import tinycolor from 'tinycolor2';
import { ThemeModule } from './store/modules/theme.module';
import { toggleTheme } from './utils/dom.util';
import { ConfigProvider } from 'ant-design-vue';

export default defineComponent({ 
  setup () {
    const providerId = computed(() => ProviderModule.providerId)
    onMounted(() => {
      toggleTheme(ThemeModule.themeType);
    })
    // 这是ant-design-vue默认的，可以根据情况变更
    const colorState = reactive({
      primaryColor: '#1890ff',
      errorColor: '#ff4d4f',
      warningColor: '#faad14',
      successColor: '#52c41a',
      infoColor: '#1890ff'
    });
    watch(
      () => providerId.value,
      (val, oldval) => {
        if (val !== oldval && val) {
          OpenConsoleApi.getConsoleStyle(val).then((res: any) => {
            const url = res.contentUrl ? '/no_auth_ewei_attachment?contentUrl=' + res.contentUrl : ''
            ProviderModule.setProviderMainPic(url)
            nextTick(() => {
              const link: HTMLLinkElement = document.querySelector("link[rel*='icon']") || document.createElement('link')
              link.rel = 'shortcut icon'
              link.type = 'image/x-icon'
              link.href = url
              document.head.appendChild(link)
              const headBackgroundColor = res.headBackgroundColor || "#3bb6ee";
              // 后续的样式设置，请以--sys开头，代表系统设置的
              document.documentElement.style.setProperty('--sys-main-color', headBackgroundColor)
              document.documentElement.style.setProperty('--sys-hover-color', tinycolor.mix('#ffffff', headBackgroundColor, 6).toString())
              document.documentElement.style.setProperty('--sys-table-color', tinycolor.mix('#ffffff', '#A1ABC2', 5).toString())
              colorState.primaryColor = headBackgroundColor
              ConfigProvider.config({
                theme: colorState
              });
            })
          })
        }
      }
    )
    return {
      zhCN
    }
  }
})
